export interface LanguageItem {
    language: string;
    code: IsoTwoLetterCode6391;
}

type IsoTwoLetterCode6391 = "en" | "nl"| "fr";

const languageList: LanguageItem[] = [
    {language: "English", code: "en"},
    {language: "Nederlands", code: "nl"},
    {language: "Français", code: "fr"}
];
export default languageList;